import {getLabelByField} from "../../utils/fields/opportunities";
import {formatLargeNumberToMoney} from "../../utils/general.js";

const columns = [
	// {
	// 	id: 'Id',
	// 	name: 'Opportunity Id',
	// 	selector: row => row.Id,
	// 	// cell: row => <div className="link18" onClick={() => {}}>{row.opportunity_id}</div>,
	// 	width: '250px'
	// },
	{
		id: 'Name',
		name: getLabelByField('Name'),
		sortable: true,
		selector: row => row.Name,
		cell: row => row.Name,
		width: '1fr'
	}, {
		id: 'AccountName',
		name: 'Account Name',
		sortable: true,
		selector: row => row.AccountName,
		cell: row => row.Account?.Name,
		width: '200px'
	}, {
		id: 'EndCustomer',
		name: 'End Customer',
		sortable: true,
		selector: row => row.End_Customer__r?.Name,
		cell: row => row.End_Customer__r?.Name,
		width: '200px'
	}, {
		id: 'Customer_Status__c',
		name: 'Customer Status',
		sortable: true,
		selector: row => row.Customer_Status__c,
		cell: row => row.Customer_Status__c,
		width: '150px'
	}, {
		id: 'StageName',
		name: 'Stage',
		sortable: true,
		selector: row => row.StageName,
		cell: row => row.StageName,
		width: '150px'
	}, {
		id: 'Priority__c',
		name: 'Priority',
		sortable: true,
		selector: row => row.Priority__c,
		cell: row => row.Priority__c,
		width: '150px'
	}
];

export default columns;
